module.exports = __webpack_public_path__ + "static/Artboard_4-86ba5f3115122a57032207dbc77a02b7.svg";